import { render, staticRenderFns } from "./SelectConfig.vue?vue&type=template&id=3c9495a0&scoped=true&"
import script from "./SelectConfig.vue?vue&type=script&lang=js&"
export * from "./SelectConfig.vue?vue&type=script&lang=js&"
import style0 from "./SelectConfig.vue?vue&type=style&index=0&id=3c9495a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9495a0",
  null
  
)

export default component.exports